<template>
  <div>
    {{
      $t("message.title.Checked") + data.selectRecords + $t("message.title.resultsNums") }}
    {{
      $t("message.title.totalResults") + data.totalRecords + $t("message.title.resultsNums")
    }}
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['data']
}
</script>
